/*
Copyright (C) 2020 Broadleaf Commerce.

Licensed under the Broadleaf End User License Agreement (EULA),
Version 1.1 (the “Commercial License” located at
http://license.broadleafcommerce.org/commercial_license-1.1.txt).

Alternatively, the Commercial License may be replaced with a mutually
agreed upon license (the “Custom License”) between you and
Broadleaf Commerce. You may not use this file except in compliance
with the applicable license.
*/
import { defineMessages } from 'react-intl';

const paymentTypes = defineMessages({
  invoiceCredit: {
    id: 'InvoiceGridUtils.paymentTypes.invoice-credit',
    defaultMessage: 'Invoice',
    description: ''
  },
  storeCredit: {
    id: 'InvoiceGridUtils.paymentTypes.store-credit',
    defaultMessage: 'Invoice (Old)',
    description: ''
  },
  wire: {
    id: 'InvoiceGridUtils.paymentTypes.wire',
    defaultMessage: 'Wire',
    description: ''
  },
  paypal: {
    id: 'InvoiceGridUtils.paymentTypes.paypal',
    defaultMessage: 'PayPal',
    description: ''
  },
  creditCard: {
    id: 'InvoiceGridUtils.paymentTypes.credit-card',
    defaultMessage: 'Credit Card',
    description: ''
  },
  other: {
    id: 'InvoiceGridUtils.paymentTypes.other',
    defaultMessage: 'Other',
    description: ''
  }
});

const resting = defineMessages({
  submitted: {
    id: 'InvoiceGridUtils.statusOptions.resting.submitted',
    defaultMessage: 'Submitted',
    description: ''
  },
  rejected: {
    id: 'InvoiceGridUtils.statusOptions.resting.rejected',
    defaultMessage: 'Rejected',
    description: ''
  },
  reimbursed: {
    id: 'InvoiceGridUtils.statusOptions.resting.reimbursed',
    defaultMessage: 'Reimbursed',
    description: ''
  },
  invoicePaid: {
    id: 'InvoiceGridUtils.statusOptions.resting.invoicePaid',
    defaultMessage: 'Invoice Paid',
    description: ''
  },
  disputed: {
    id: 'InvoiceGridUtils.statusOptions.resting.disputed',
    defaultMessage: 'Disputed',
    description: ''
  }
});

const active = defineMessages({
  orderProcessing: {
    id: 'InvoiceGridUtils.statusOptions.active.orderProcessing',
    defaultMessage: 'Order Processing',
    description: ''
  },
  creditPending: {
    id: 'InvoiceGridUtils.statusOptions.active.creditPending',
    defaultMessage: 'Credit Pending',
    description: ''
  },
  readyToSubmit: {
    id: 'InvoiceGridUtils.statusOptions.active.readyToSubmit',
    defaultMessage: 'Ready to Submit',
    description: ''
  },
  openRevMedInvoice: {
    id: 'InvoiceGridUtils.statusOptions.active.openRevMedInvoice',
    defaultMessage: 'Open RevMed Invoice',
    description: ''
  }
});

const error = defineMessages({
  holdForReview: {
    id: 'InvoiceGridUtils.statusOptions.active.holdForReview',
    defaultMessage: 'Hold for Review',
    description: ''
  },
  requiresPo: {
    id: 'InvoiceGridUtils.statusOptions.active.requiresPo',
    defaultMessage: 'Requires PO',
    description: ''
  }
});

const statusOptions = {
  resting,
  active,
  error
};

const headersMain = defineMessages({
  submitDate: {
    id: 'invoices.columns.submit-date',
    defaultMessage: 'Submit Date',
    description: ''
  },
  invoiceStatus: {
    id: 'invoices.columns.invoice-status',
    defaultMessage: 'Invoice Status',
    description: ''
  },
  invoiceStatusReason: {
    id: 'invoices.columns.invoice-status-reason',
    defaultMessage: 'Invoice Status Reason',
    description: ''
  },
  invoiceDate: {
    id: 'invoices.columns.invoice-date',
    defaultMessage: 'Invoice Date',
    description: ''
  },
  paymentType: {
    id: 'invoices.columns.payment-type',
    defaultMessage: 'Payment Type',
    description: ''
  },
  orderNumber: {
    id: 'invoices.columns.order-number',
    defaultMessage: 'Order Number',
    description: ''
  },
  invoiceNumber: {
    id: 'invoices.columns.invoice-number',
    defaultMessage: 'Invoice Number',
    description: ''
  },
  poNumber: {
    id: 'invoices.columns.po-number',
    defaultMessage: 'PO Number',
    description: ''
  },
  billToOrg: {
    id: 'invoices.columns.bill-to-org',
    defaultMessage: 'Bill To Org',
    description: ''
  },
  invoiceTotal: {
    id: 'invoices.columns.invoice-total',
    defaultMessage: 'Invoice Total',
    description: ''
  },
  revMedCreditAmount: {
    id: 'invoices.columns.revmed-credit-amount',
    defaultMessage: 'RevMed Credit',
    description: ''
  },
  invoiceBalance: {
    id: 'invoices.columns.invoice-balance',
    defaultMessage: 'Invoice Balance',
    description: ''
  }
});

const rowActions = defineMessages({
  rebase: {
    id: 'InvoiceGridUtils.rowAction.rebase',
    defaultMessage: 'Rebase',
    description: ''
  }
});

const changeTypes = defineMessages({
  create: {
    id: 'InvoiceGridUtils.headers.changeTypes.create',
    defaultMessage: 'Create',
    description: ''
  },
  update: {
    id: 'InvoiceGridUtils.headers.changeTypes.update',
    defaultMessage: 'Update',
    description: ''
  },
  delete: {
    id: 'InvoiceGridUtils.headers.changeTypes.delete',
    defaultMessage: 'Delete',
    description: ''
  }
});

const headers = {
  changeTypes,
  ...headersMain
};

const gridActions = defineMessages({
  submit: {
    id: 'InvoiceGridUtils.gridActions.submit',
    defaultMessage: 'Submit',
    description: ''
  },
  markPaid: {
    id: 'InvoiceGridUtils.gridActions.markPaid',
    defaultMessage: 'Mark Paid',
    description: ''
  },
  bulkExport: {
    id: 'InvoiceGridUtils.gridActions.bulkExport',
    defaultMessage: 'Invoice Export',
    description: ''
  },
  viewDetails: {
    id: 'InvoiceGridUtils.gridActions.viewDetails',
    defaultMessage: 'View',
    description: ''
  },
  downloadOrderInvoice: {
    id: 'InvoiceGridUtils.gridActions.downloadOrderInvoice',
    defaultMessage: 'Download Invoice',
    description: ''
  },
  criteriaQuery: {
    id: 'InvoiceGridUtils.gridActions.criteriaQuery',
    defaultMessage: 'Filter',
    description: ''
  }
});

const mainMessages = defineMessages({
  openRemitra: {
    id: 'InvoicesView.openRemitra',
    defaultMessage: 'Open Remitra',
    description: ''
  },
  openRevMed: {
    id: 'InvoicesView.openRevMed',
    defaultMessage: 'Open RevMed',
    description: ''
  },
  openExternal: {
    id: 'InvoicesView.openExternal',
    defaultMessage: 'Open Wire/Other',
    description: ''
  },
  orderProcessing: {
    id: 'InvoicesView.orderProcessing',
    defaultMessage: 'Order Processing',
    description: ''
  },
  heldInvoices: {
    id: 'InvoicesView.heldInvoices',
    defaultMessage: 'Held Invoices',
    description: ''
  },
  invoiceSubmissionHistory: {
    id: 'InvoicesView.invoiceSubmissionHistory',
    defaultMessage: 'Submitted Invoices',
    description: ''
  },
  otherInvoices: {
    id: 'InvoicesView.otherInvoices',
    defaultMessage: 'Other Invoices',
    description: ''
  },
  title: {
    id: 'InvoicesView.title',
    defaultMessage: 'Invoices',
    description: ''
  }
});

export default {
  headers,
  gridActions,
  rowActions,
  statusOptions,
  paymentTypes,
  ...mainMessages
};
